<template>
    <div class="text-center">
        <v-dialog
            :value="dialog"
            fullscreen
            persistent
        >
            <v-card >
                <v-card-title class="headline grey lighten-2 py-4">
                    <span class=" policy-title">
                        <v-icon class="warning--text mr-2 mb-1" size="30">
                            mdi-alert
                        </v-icon>
                        <strong>
                            POLÍTICA DE USO DE WHATSAPP BUSINESS
                        </strong>
                    </span  >
                </v-card-title>

                <v-card-text class="policy-text title py-4 px-4">

                    <div class="jb-header">
                        <strong>JB SINIESTROS S. A. DE C. V. </strong> <br><br>
                    </div>
                    Esta política regula el uso de la cuenta de WhatsApp Business de JB SINIESTROS S. A. DE C. V., en lo sucesivo “JB” y define los derechos y obligaciones de la empresa, con sus proveedores, exclusivamente para la notificación de eventos relacionados con la gestión de siniestros, pagos y operaciones contractuales. <br>

                    Su objetivo es garantizar el cumplimiento de los términos de servicio de WhatsApp Business, las leyes aplicables y la protección de los datos personales. <br><br>

                    <strong class="headline font-weight-bold">I.	ALCANCE</strong><br><br>

                    Esta política aplica a todos sus proveedores autorizados que utilicen la cuenta de WhatsApp Business de “JB”. <br><br>

                    <strong class="headline font-weight-bold">II.	REQUISITOS LEGALES Y DE REGISTRO</strong><br><br>

                    <ul>
                        <li>
                            La persona que registre y administre la cuenta debe tener al menos 18 años y capacidad legal para representar a la empresa/proveedor.
                        </li>
                        <li>
                            El proveedor proporcionará información veraz, actualizada y completa para el registro, incluyendo razón social, datos fiscales y número telefónico válido.
                        </li>
                        <li>
                            El nombre utilizado en WhatsApp debe ser fiel a la identidad corporativa, sin ser falso, engañoso o que infrinja derechos de terceros.
                        </li>
                    </ul> <br>

                    <strong class="headline font-weight-bold">III.	USO PERMITIDO.</strong><br><br>

                    <ul>
                        <li>
                            El uso de WhatsApp Business será exclusivamente para fines informativos, consistentes en la notificación de eventos relacionados con la gestión de siniestros, pagos y operaciones contractuales, y no para fines personales.
                        </li>
                        <li>
                            Todas las comunicaciones deben cumplir con las leyes nacionales e internacionales aplicables.
                        </li>
                        <li>
                            Está prohibido utilizar la cuenta para fines ilegales, fraudulentos o que atenten contra la reputación de “JB”
                        </li>
                    </ul><br><br>

                    <strong class="headline font-weight-bold">IV.	CONSENTIMIENTO DE PROVEEDORES.</strong><br><br>

                    <ul>
                        <li>
                            Antes de enviar comunicaciones, se debe contar con el consentimiento expreso de los proveedores.
                        </li>
                        <li>
                            Se debe informar a los proveedores sobre el uso de sus datos y su derecho a solicitar la baja (opt-out).
                        </li>
                    </ul><br><br>

                    <strong class="headline font-weight-bold">V.	SEGURIDAD Y RESPONSABILIDAD</strong><br><br>

                    <ul>
                        <li>
                            Solo personal autorizado tendrá acceso a la cuenta de WhatsApp Business.
                        </li>
                        <li>
                            Se prohíbe compartir información de proveedores en grupos de mensajería no autorizados o con terceros no relacionados con la gestión de siniestros.
                        </li>
                        <li>
                            Ante cualquier incidente de seguridad o acceso no autorizado, se deberá informar de inmediato al área responsable.
                        </li>
                    </ul><br>

                    <strong class="headline font-weight-bold">VI.	CONTENIDOS Y MENSAJES</strong><br><br>

                    <ul>
                        <li>
                            Está prohibido enviar mensajes ofensivos, difamatorios, discriminatorios, de odio, sexuales explícitos o que infrinjan derechos de terceros.
                        </li>
                        <li>
                            No se permitirá el envío de spam, cadenas de mensajes, esquemas piramidales ni contenido engañoso.
                        </li>
                        <li>
                            Los mensajes deben ser claros, relevantes y útiles para los usuarios.
                        </li>
                    </ul><br>

                    <strong class="headline font-weight-bold">VII.	PROPIEDAD INTELECTUAL</strong><br><br>

                    <ul>
                        <li>
                            “JB” conservará los derechos de autor sobre sus contenidos.
                        </li>
                        <li>
                            No se usarán materiales de terceros sin la autorización correspondiente.
                        </li>
                        <li>
                            WhatsApp tiene licencia limitada para usar los contenidos transmitidos únicamente en relación con el funcionamiento del servicio.
                        </li>
                    </ul><br>

                    <strong class="headline font-weight-bold">VIII.	PROTECCIÓN DE DATOS</strong><br><br>

                    <ul>
                        <li>
                            JB” actuará como responsable del tratamiento de los datos de clientes.
                        </li>
                        <li>
                            Se aplicarán medidas técnicas y organizativas de seguridad para proteger los datos personales.
                        </li>
                        <li>
                            Los datos solo serán almacenados y tratados mientras sea necesario para los fines autorizados.
                        </li>
                    </ul><br>

                    <strong class="headline font-weight-bold">IX.	CUMPLIMIENTO LEGAL</strong><br><br>

                    <ul>
                        <li>
                            “JB” cumplirá con las leyes locales de comercio electrónico, protección al consumidor, comunicaciones digitales y protección de datos.
                        </li>
                        <li>
                            También cumplirá con regulaciones internacionales en caso de aplicar (ej. GDPR, sanciones de comercio internacional).
                        </li>
                    </ul><br>

                    <strong class="headline font-weight-bold">X.	LIMITACIONES DE RESPONSABILIDAD</strong><br><br>

                    <ul>
                        <li>
                            “JB” no garantiza que el servicio de WhatsApp funcione sin interrupciones, errores o demoras.
                        </li>
                        <li>
                            “JB” no será responsable por fallas externas ajenas a su control, incluyendo caídas del servicio de WhatsApp, desastres naturales o ataques cibernéticos.
                        </li>
                        <li>
                            El uso indebido de la cuenta por parte de los empleados será motivo de sanciones internas.
                        </li>
                        <li>
                            El proveedor es responsable de mantener actualizado su número de contacto y garantizar que solo personal autorizado tenga acceso al dispositivo en el que recibe las notificaciones.
                        </li>
                        <li>
                            “JB” no se hace responsable por accesos indebidos derivados de negligencia del proveedor en el resguardo de su dispositivo móvil.
                        </li>
                    </ul><br>

                    <strong class="headline font-weight-bold">XI.	MODIFICACIONES Y TERMINACIÓN</strong><br><br>

                    <ul>
                        <li>
                            “JB” podrá modificar esta política cuando sea necesario, comunicando los cambios al personal autorizado.
                        </li>
                        <li>
                            WhatsApp se reserva el derecho de suspender la cuenta en caso de incumplimiento de sus términos.
                        </li>
                        <li>
                            “JB” podrá cerrar la cuenta en cualquier momento, debiendo cesar el uso y eliminar accesos.
                        </li>
                    </ul><br>

                    CONTACTO <br>
                    Para dudas, quejas o reportes relacionados con esta política: <br>
                    Responsable interno: (Maribel Sanchez Flores / Karla Fernanda Ramirez Sánchez) <br>
                    Correo: <a href="mailto:proveedores@jbge.com.mx">proveedores@jbge.com.mx</a> / <a href="mailto:karla.ramirez@jbge.com.mx">karla.ramirez@jbge.com.mx</a> <br>
                    Última actualización: (25/09/2025) <br>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="justify-end">
                    <v-btn
                        class="submit-btn"
                        color="green"
                        block
                        @click="submit"
                    >
                        Acepto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>

export default {
  name: 'PolicyWhatsappBusiness',
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    submit: {
      required: true,
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
    display: flex;
    flex-direction: column;

    .policy-text {
          flex-grow: 1;
    }
}
  .policy-title{
    word-break: break-word;
  }
.submit-btn {
    font-size: 24px;
    font-weight: 800;
}
.jb-header {
  display: flex;
  justify-content: center;
}
</style>
